import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_CATEGORY } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface getProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyCategories = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_CATEGORY(communityId)}`);

const useGetPropertyCategories = ({
  communityId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-categories"],
    queryFn: () => getPropertyCategories(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyCategories;
